"use client";

import GlobalStyles from "@/app/globalStyles.ts";
import Trackers from "@template/layout/Root/Trackers";
import { useEffect, useState } from "react";
import { useTypedDispatch } from "@/redux/helpers/hooks.ts";
import { setGlobalComponents, setTheme } from "@/redux/slices/store";
import { TGlobalComponents } from "@/redux/slices/store/types.ts";
import { ImportTheme } from "@template/theme";
import Providers from "@template/layout/Root/Providers.tsx";

const GlobalComponents = ({
  components,
}: {
  components: TGlobalComponents;
}) => {
  const dispatch = useTypedDispatch();
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    if (mounted) return;
    setMounted(true);

    dispatch(setGlobalComponents(components));
  }, [mounted]);

  return <></>;
};

const ThemeSetter = ({ theme }: { theme: ImportTheme }) => {
  const dispatch = useTypedDispatch();
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    if (mounted) return;
    setMounted(true);

    dispatch(setTheme(theme));
  }, [mounted]);

  return <></>;
};

const Root = ({
  children,
  globalComponents,
  storeTheme,
}: {
  children: any;
  globalComponents?: any;
  storeTheme: ImportTheme;
}) => {
  return (
    <Providers>
      <GlobalStyles />
      <Trackers />
      {globalComponents && <GlobalComponents components={globalComponents} />}
      <ThemeSetter theme={storeTheme} />
      {children}
    </Providers>
  );
};

export default Root;
